import { win } from '@wix/cashier-common/dist/src/utils/win';

const getFrameVisibilityObserver = () => win.matchMedia('screen and (min-width: 1px)');

export const isFrameVisible = (): boolean => getFrameVisibilityObserver().matches;

export const waitForFrameVisible = async (): Promise<void> => {
  const widthObserver = getFrameVisibilityObserver();

  if (!widthObserver.matches) {
    await new Promise<void>((resolve) => {
      const listener = (event) => {
        if (event.matches) {
          widthObserver.removeListener(listener);
          resolve();
        }
      };
      widthObserver.addListener(listener);
    });
  }
};
